import { ref } from "vue";
import { defineStore } from "pinia";
import { getInfo, logout } from "@/api/login";
import { ResponseData } from "@/interface/userInfo";
import { getMineInfo, getNoReadMsg } from "@/api/home";
import { getUserDeviceType } from "@/utils/public";
import { saveSkipRecord } from "@/api";
import { removeToken } from "@/utils";
export const userInfoStore = defineStore("userInfo", () => {
  const userInfo = ref();
  const permissions = ref();
  const roles = ref();
  // const avatar = ref(defAva);
  const noReadMsgNum = ref<number>(0);
  const mineInfo = ref();
  const jobIdArr = ref<Array<{ userId: string | undefined; jobId: string }>>([]);
  // const messageNum = ref(0);
  const getuserInfo = (): Promise<ResponseData> => {
    return new Promise((resolve, reject) => {
      getInfo()
        .then((res: ResponseData) => {
          if (res && res.code === 200) {
            userInfo.value = res.user;
            roles.value = res.roles;
            permissions.value = res.permissions;
            userInfo.value.avatar = window.VITE_APP_BASE_API
              ? window.VITE_APP_BASE_API.replace("/api", "") + res.user?.avatar
              : import.meta.env.VITE_APP_BASE_API.replace("/api", "") + res.user?.avatar;
            // avatar.value = res.user && res.user.avatar ? res.user.avatar : defAva;
            // if (res.user) {
            // avatar.value = res.user.avatar ? (window.VITE_APP_BASE_API || import.meta.env.VITE_APP_BASE_API) + res.user.avatar : defAva;
            // }
            resolve(res);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
  const getMineInfoFun = (): Promise<ResponseData> => {
    return new Promise((resolve, reject) => {
      getMineInfo()
        .then((res: ResponseData) => {
          if (res && res.code === 200) {
            // console.log("嘎哈");

            mineInfo.value = res.data;
            resolve(res);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
  const loginOut = (): Promise<boolean> => {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          destoryInfo();
          removeToken();
          resolve(true);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  const destoryInfo = () => {
    userInfo.value = undefined;
    permissions.value = undefined;
    roles.value = undefined;
  };
  const getNoReadMsgNum = async () => {
    try {
      const res = await getNoReadMsg();
      if (res && res.code == 200) {
        noReadMsgNum.value = res.data;
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleJudgeAuth = (arr: Array<string>): boolean => {
    let flag = false;
    const all_permission = "*:*:*";
    if (arr && arr instanceof Array && arr.length > 0) {
      const permissionFlag = arr;
      const hasPermissions = permissions.value.some((permission: string) => {
        return all_permission === permission || permissionFlag.includes(permission);
      });
      flag = hasPermissions;
    } else {
      throw new Error(`请设置操作权限标签值`);
    }
    return flag;
  };

  const handleAllJudgeAuth = (arr: Array<string>): boolean => {
    let flag = false;
    const all_permission = "*:*:*";
    if (arr && arr instanceof Array && arr.length > 0) {
      const permissionFlag = arr;
      const hasPermissions = permissionFlag.reduce((prev: boolean, next: string) => {
        prev = permissions.value.includes(all_permission) || permissions.value.includes(next);
        if (!prev) prev = false;
        return prev;
      }, true);
      flag = hasPermissions;
    } else {
      throw new Error(`请设置操作权限标签值`);
    }
    return flag;
  };

  // 上传用户跳转信息
  const uploadUserSkipInfo = async (system: number) => {
    try {
      const res = await saveSkipRecord({
        resource: getUserDeviceType() == "mobile" ? 2 : 1,
        target: system
      });
    } catch (err) {
      console.log(err);
    }
  };

  const setNoReadMsgNum = (val: number) => {
    noReadMsgNum.value = val;
  };
  return {
    userInfo,
    mineInfo,
    // avatar,
    permissions,
    roles,
    noReadMsgNum,
    jobIdArr,
    handleJudgeAuth,
    handleAllJudgeAuth,
    getuserInfo,
    getMineInfoFun,
    loginOut,
    destoryInfo,
    setNoReadMsgNum,
    getNoReadMsgNum,
    uploadUserSkipInfo
  };
});
